import * as S from './styles'

import { useRef, useState } from 'react'

const Footer = () => {
  return (
    <S.Wrapper>
      <S.FrameFooter
        title="footer"
        id="iframe-footer"
        src={`${process.env.REACT_APP_URL_MAIN}/conteudo-footer-react`}
        width="100%"
        frameBorder="0"
      ></S.FrameFooter>
    </S.Wrapper>

    // <S.Wrapper className="footer">
    //   <S.FooterWrapper className="wrapper">
    //     <S.FooterColumns className="footer-columns">
    //       <S.FooterColumn className="footer-column">
    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">Gimba</S.FooterTitle>
    //           <S.FooterList className="footer-list">
    //             {mock.content.gimba.map(({ name, link }, index) => (
    //               <S.FooterListItem
    //                 key={`${name}${index}`}
    //                 className="footer-item"
    //               >
    //                 <a href={link}>{name}</a>
    //               </S.FooterListItem>
    //             ))}
    //           </S.FooterList>
    //         </S.FooterBox>
    //       </S.FooterColumn>

    //       <S.FooterColumn className="footer-column">
    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">Para Você</S.FooterTitle>
    //           <S.FooterList className="footer-list">
    //             {mock.content.paravoce.map(({ name, link }, index) => (
    //               <S.FooterListItem
    //                 key={`${name}${index}`}
    //                 className="footer-item"
    //               >
    //                 <a href={link}>{name}</a>
    //               </S.FooterListItem>
    //             ))}
    //           </S.FooterList>
    //         </S.FooterBox>
    //       </S.FooterColumn>

    //       <S.FooterColumn className="footer-column">
    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">Serviços</S.FooterTitle>
    //           <S.FooterList className="footer-list">
    //             {mock.content.servicos.map(({ name, link }, index) => (
    //               <S.FooterListItem
    //                 key={`${name}${index}`}
    //                 className="footer-item"
    //               >
    //                 <a href={link}>{name}</a>
    //               </S.FooterListItem>
    //             ))}
    //           </S.FooterList>
    //         </S.FooterBox>
    //       </S.FooterColumn>

    //       <S.FooterColumn className="footer-column">
    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">Fornecedor</S.FooterTitle>
    //           <S.FooterList className="footer-list">
    //             {mock.content.fornecedor.map(({ name, link }, index) => (
    //               <S.FooterListItem
    //                 key={`${name}${index}`}
    //                 className="footer-item"
    //               >
    //                 <a href={link}>{name}</a>
    //               </S.FooterListItem>
    //             ))}
    //           </S.FooterList>
    //         </S.FooterBox>

    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">Corporativo</S.FooterTitle>
    //           <S.FooterList className="footer-list">
    //             {mock.content.corporativo.map(({ name, link }, index) => (
    //               <S.FooterListItem
    //                 key={`${name}${index}`}
    //                 className="footer-item"
    //               >
    //                 <a href={link}>{name}</a>
    //               </S.FooterListItem>
    //             ))}
    //           </S.FooterList>
    //         </S.FooterBox>
    //       </S.FooterColumn>

    //       <S.FooterColumn className="footer-column">
    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">
    //             Compra segura
    //           </S.FooterTitle>
    //           <S.FooterImage src={ImgCompraSegura} className="footer-image" />
    //         </S.FooterBox>

    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">Pagamento</S.FooterTitle>
    //           <a href={`${process.env.REACT_APP_URL_MAIN}/regras-funcionamento`}>
    //             <S.FooterImage src={ImgPagamento} className="footer-image" />
    //           </a>
    //         </S.FooterBox>

    //         <S.FooterBox className="footer-box">
    //           <S.FooterTitle className="footer-title">
    //             Redes Sociais
    //           </S.FooterTitle>
    //           <S.FooterList className="footer-social-media">
    //             {mock.content.socialmedia.map(({ link, icon }, index) => (
    //               <S.FooterSocialMediaItem
    //                 key={`${link}${index}`}
    //                 className="footer-social-media-item"
    //               >
    //                 <a href={link} target="_blank" rel="noreferrer" passHref>
    //                   <i className={`icon ${icon}`}></i>
    //                 </a>
    //               </S.FooterSocialMediaItem>
    //             ))}
    //           </S.FooterList>
    //         </S.FooterBox>
    //       </S.FooterColumn>
    //     </S.FooterColumns>
    //     <S.FooterInformations className="footer-informations">
    //       <p>
    //         <strong>Razão Social:</strong>
    //         Supricorp Suprimentos Ltda / CNPJ: 54.651.716/0011-50
    //       </p>
    //       <p>
    //         <strong>Endereço:</strong>
    //         Avenida Prefeito João Vilallobo Quero, 1160 - Jardim Belval - Barueri
    //         - SP | CEP: 06422-122
    //       </p>
    //     </S.FooterInformations>
    //   </S.FooterWrapper>
    // </S.Wrapper>
  )
}

export default Footer
